import React, { useState } from 'react';
import { updateBotStatus } from '../services/api';

export default function BotStatusForm({ onSuccess }) {
  const [type, setType] = useState('PLAYING');
  const [status, setStatus] = useState('online');
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    
    try {
      await updateBotStatus({ type, text, status });
      setMsg('Статус успешно изменен!');
      if (onSuccess) onSuccess();
    } catch (error) {
      setMsg('Ошибка: ' + (error.response?.data?.error || 'Неизвестная ошибка'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bot-status-container">
      <h4>Управление ботом</h4>
      <form onSubmit={handleSubmit} className="admin-form">
        <div className="row-inputs" style={{ display: 'flex', gap: '10px' }}>
          <select 
             value={type} 
             onChange={e => setType(e.target.value)} 
             style={{ flex: 1 }}
          >
            <option value="PLAYING">Играет в</option>
            <option value="WATCHING">Смотрит</option>
            <option value="LISTENING">Слушает</option>
            <option value="COMPETING">Соревнуется в</option>
            <option value="CUSTOM">Кастомный</option> 
          </select>

          <select 
             value={status} 
             onChange={e => setStatus(e.target.value)} 
             style={{ width: '50%' }}
          >
            <option value="online">🟢 Онлайн</option>
            <option value="idle">🌙 Неактивен</option>
            <option value="dnd">⛔ Не беспокоить</option>
            <option value="invisible">👻 Невидимка</option>
          </select>
        </div>

        <input 
          type="text" 
          value={text} 
          onChange={e => setText(e.target.value)} 
          placeholder="Текст статуса (напр. Раздача слонов)" 
          required 
          
        />

        <button 
            type="submit" 
            className="primary-btn" 
            disabled={loading}
            style={{ marginTop: '10px', width: '100%', padding: '10px', background: 'rgb(88, 103, 240)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
        >
          {loading ? '...' : 'Обновить статус'}
        </button>
      </form>
      {msg && <p style={{ textAlign: 'center', marginTop: '10px', color: msg.includes('Ошибка') ? '#f04747' : 'rgb(102, 241, 144)' }}>{msg}</p>}
    </div>
  );
}